import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import P11AdminLayout from "./P11AdminLayout";
import { useP11Role } from "./P11AdminGuard";
import { P11 } from "./p11shared";

// NOTIFICATIONS (log) + SETTINGS (P11-rollen binnen bestaand admin-systeem).
export function P11AdminNotifications() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/project11/admin/notifications").then(({ data }) => setItems(data.items || [])).catch(() => setItems([])); }, []);
  return (
    <P11AdminLayout>
      <div data-testid="p11-admin-notifications">
        <div className="p11-label-yellow">NOTIFICATIONS</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-8">LOG.</h1>
        {items === null ? <span className="p11-label">…</span> : items.length === 0 ? (
          <div className="p11-label" style={{ color: P11.gray }} data-testid="p11-notifications-empty">Nog geen notificaties verstuurd.</div>
        ) : (
          <div className="divide-y" style={{ borderColor: P11.border }} data-testid="p11-notifications-list">
            {items.map((n) => (
              <div key={n.id} className="py-3 flex flex-wrap gap-4 p11-label" style={{ color: P11.gray2 }} data-testid={`p11-notification-${n.id}`}>
                <span style={{ color: P11.yellow }}>{n.type}</span>
                <span className="flex-1 min-w-40">{n.subject}</span>
                <span>{n.email}</span>
                <span>{n.created_at?.slice(0, 16).replace("T", " ")}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </P11AdminLayout>
  );
}

export function P11AdminSettings() {
  const role = useP11Role();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/project11/admin/roles").then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  useEffect(() => { if (role === "owner") load(); }, [role]); // eslint-disable-line react-hooks/exhaustive-deps

  const setRole = async (email, p11_role) => {
    setBusy(true);
    try {
      await api.put("/project11/admin/roles", { email, p11_role });
      toast.success("Rol bijgewerkt");
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Mislukt"); } finally { setBusy(false); }
  };

  return (
    <P11AdminLayout>
      <div data-testid="p11-admin-settings">
        <div className="p11-label-yellow">SETTINGS</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-4">PERMISSIONS.</h1>
        <p className="text-sm mb-8" style={{ color: P11.gray2 }}>Project 11*-rollen binnen het bestaande JOH. admin-systeem. OWNER: volledig beheer. COACH: aanwezigheid en stempels. VIEWER: alleen operationeel lezen (geen gezondheids- of noodcontactgegevens).</p>
        {role !== "owner" ? (
          <div className="p11-label" style={{ color: P11.gray }} data-testid="p11-settings-denied">Alleen owners beheren rechten.</div>
        ) : items === null ? <span className="p11-label">…</span> : (
          <div className="divide-y" style={{ borderColor: P11.border }} data-testid="p11-roles-list">
            {items.map((a) => (
              <div key={a.email} className="py-4 flex flex-wrap items-center gap-4" data-testid={`p11-role-row-${a.email}`}>
                <div className="flex-1 min-w-48">
                  <div className="text-sm" style={{ color: P11.text }}>{a.name || a.email}</div>
                  <div className="p11-label mt-1">{a.email} · ADMIN-ROL: {a.admin_role.toUpperCase()}</div>
                </div>
                <div className="flex gap-2">
                  {["owner", "coach", "viewer"].map((r) => (
                    <button key={r} onClick={() => setRole(a.email, r)} disabled={busy || (a.admin_role === "owner" && r !== "owner")}
                      className="p11-label px-3 py-1.5 border transition-colors disabled:opacity-40"
                      style={{ borderColor: a.p11_role === r ? P11.yellow : P11.border, color: a.p11_role === r ? P11.yellow : P11.gray2 }}
                      data-testid={`p11-role-${a.email}-${r}`}>{r.toUpperCase()}</button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </P11AdminLayout>
  );
}
